import React from 'react'
import CoachName from 'src/legacy/components/CoachName/CoachName'

const sourceLabel = (source: string | null | undefined): string | null => {
  const [system, , id] = (source ?? '').split(':')

  switch (system) {
    case 'dataSheet':
      return 'from the old tracking sheet'
    case 'dashboard':
      return 'from the dashboard'
    case 'external':
      return `from partner (${id})`
    case 'form':
      return `from Typeform (ID: ${id})`
    case 'formstack':
      return `from Formstack (ID: ${id})`
    case 'response':
      return 'from the app'
    default:
      return null
  }
}

const SubmittedBy = ({ coachID, source }: { coachID?: string | null; source?: string | null }) => {
  if (coachID) {
    return (
      <>
        by <CoachName coachID={coachID} />
      </>
    )
  }

  return <>{sourceLabel(source)}</>
}

export default SubmittedBy
